export const AVAILABLE_SIZES = ["P", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL"]; 